import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "@components/Loader/Loader";
import PrivateRoute from "./PrivateRoute";
import { PATHS } from "config/paths";

// Pages
import Home from "../pages/home/Home";
import InvoiceListPage from "../pages/Invoices";
import CreateInvoicePage from "../pages/createInvoice";
import QuoteListPage from "../pages/Quotes";
import CreateQuotePage from "../pages/createQuote";
import AvoirListPage from "@pages/avoirs/avoirList";
import CreateAvoirPage from "@pages/avoirs/createAvoir/createAvoir";
import OffersPage from "@pages/Offers/Offers";
import SuppliersPage from "@pages/suppliersPage/SuppliersPage";
import ClientsPage from "@pages/ClientsPage/ClientsPage";
import ExpensesPage from "@pages/ExpensesPage/ExpensesPage";
import CompanyConfig from "@components/CompanyConfig";
import CreateNewCompany from "@components/createCompany";
import Payment from "@pages/payment/Payment";
import { PaiementSuccessSignUP } from "@components/paiementSignUp";
import NotFound from "../pages/NotFound";
import { SignaturePage } from "@pages/signature/SignaturePage";
import SignDocument from "@pages/signature/SignatureRecipientPage";
// Auth Pages
import Login from "@pages/auth/login/Login";
import Register from "@pages/auth/register/Register";
import ConfirmEmail from "@pages/auth/confirmEmail/ConfirmEmail";
import RenitialisePassword from "@pages/auth/RenitialisePassword/RenitialisePassword";
import FolderManager from "@pages/ged/pages/FolderManager/FolderManager";
import FolderDetail from "@pages/ged/pages/FolderDetail/FolderDetail";
import SuppliersConsult from "@pages/suppliersPage/suppliersConsult/SuppliersConsult";
import UsersPage from "@pages/users/userPage/UsersPage";
import RolesPage from "@pages/roles/ListeRolePage/ListeRolePage";
import ContratsListPage from "@pages/contrats/contratsList";
import ForgotPasswordForm from "../components/ForgetPasswordForm/ForgetPasswordForm";
import AppWrapper from "./AppWrapper";
import DashboardUser from "@pages/DashboardUser/DashboardUser";
// import CraDetails from "@pages/cra/components/CraDetails";
// import CraPage from "@pages/cra/pages/CraPage";
import CraDetails from "@pages/cra/CraDetails/CraDetails";
import AbsencesSection from "@pages/gestionConge/AbsencesSection/AbsencesSection";
import LeaveRequest from "@pages/gestionConge/LeaveRequest/LeaveRequest";
import ProjectsPage from "@pages/project/projectPage/ProjectPage";
import LeaveRequestValidation from "@pages/gestionConge/LeaveRequestValidation/LeaveRequestValidation";
import LeaveRequestsListPage from "@pages/gestionConge/LeaveReqestTable/LeaveReqestTable";
import TimesheetsSection from "@pages/cra/CraListeMonthPage/CraListeMonthPage";
import Timesheet from "@pages/cra/DetailsCra/DetailsCra";
import ValidationPage from "@pages/cra/validationPage/ValidationPage";
import EditCra from "@pages/cra/EditCra/EditCra";
import ConsultCra from "@pages/cra/ConsultCra/ConsultCra";
import ProjectsPageAdmin from "@pages/project/ProjectsPageAdmin/ProjectsPageAdmin";
import ProjectsPageCollab from "@pages/project/ProjectPageCollab/ProjectPageCollab";
import CRAListPage from "@pages/cra/CraListValidation/CraListValidation";
import Packs from "@pages/packs/Packs";

const Router = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path={PATHS.ROOT} element={<Home />} />
        {/* Wrap everything with AppWrapper */}
        <Route path={PATHS.REGISTER} element={<Register />} />
        <Route path={PATHS.LOGIN} element={<Login />} />
        <Route path={PATHS.CONFIRM_EMAIL} element={<ConfirmEmail />} />
        <Route path={PATHS.RESET_PASSWORD} element={<RenitialisePassword />} />
        <Route path={PATHS.FORGOT_PASSWORD} element={<ForgotPasswordForm />} />
        <Route path={PATHS.PAYMENT} element={<Payment />} />
        <Route path={PATHS.COMPANY} element={<CreateNewCompany />} />
        <Route
          path="/leave-request/validate/:id"
          element={<LeaveRequestValidation />}
        />
        <Route
          path={PATHS.PAIEMENT_SUCCESS}
          element={<PaiementSuccessSignUP />}
        />
        <Route path={PATHS.NOT_FOUND} element={<NotFound />} />
        <Route element={<AppWrapper />}>
          {/* Public Routes */}

          {/* Private Routes */}
          <Route
            path={PATHS.DOCUMENT.LIST}
            element={
              <PrivateRoute
                element={<FolderManager />}
                permissions="DOCUMENT"
              />
            }
          />
          <Route
            path={PATHS.CRA.DETAILS}
            element={<PrivateRoute element={<Timesheet />} permissions="CRA" />}
          />
          <Route
            path={PATHS.CRA.CONSULT}
            element={
              <PrivateRoute element={<ConsultCra />} permissions="CRA" />
            }
          />
          <Route
            path={PATHS.CRA.EDIT}
            element={<PrivateRoute element={<EditCra />} permissions="CRA" />}
          />
          <Route
            path={PATHS.CRA.VALIDE}
            element={
              <PrivateRoute
                element={<ValidationPage />}
                permissions="VALIDATEUR"
              />
            }
          />
          <Route
            path={PATHS.CRA.LIST}
            element={
              <PrivateRoute element={<TimesheetsSection />} permissions="CRA" />
            }
          />
          <Route
            path={PATHS.CRA.LISTVALIDATION}
            element={
              <PrivateRoute
                element={<CRAListPage />}
                permissions="VALIDATEUR"
              />
            }
          />
          <Route
            path={PATHS.CONGE.LIST}
            element={
              <PrivateRoute element={<AbsencesSection />} permissions="CONGE" />
            }
          />
          <Route
            path={PATHS.CONGE.CREATE}
            element={
              <PrivateRoute element={<LeaveRequest />} permissions="CONGE" />
            }
          />

          <Route
            path={PATHS.CONGE.LISTSUPPLIER}
            element={
              <PrivateRoute
                element={<LeaveRequestsListPage />}
                permissions="VALIDATEUR"
              />
            }
          />
          <Route
            path={PATHS.DOCUMENT.DETAILS}
            element={
              <PrivateRoute element={<FolderDetail />} permissions="DOCUMENT" />
            }
          />
          <Route path={PATHS.SIGNATURE.CLIENT} element={<SignDocument />} />
          <Route
            path={PATHS.PROJECT.LIST}
            element={
              <PrivateRoute element={<ProjectsPage />} permissions="PROJECT" />
            }
          />
          <Route
            path={PATHS.PROJECT.LISTA}
            element={
              <PrivateRoute
                element={<ProjectsPageAdmin />}
                permissions="PROJECT_ADMIN"
              />
            }
          />
          <Route
            path={PATHS.PROJECT.LISTC}
            element={
              <PrivateRoute
                element={<ProjectsPageCollab />}
                permissions="PROJECT_COLLAB"
              />
            }
          />
          <Route
            path={PATHS.INVOICES.LIST}
            element={
              <PrivateRoute
                element={<InvoiceListPage />}
                permissions="READ_INVOICE"
              />
            }
          />
          <Route
            path={PATHS.ROLES.LIST}
            element={
              <PrivateRoute element={<RolesPage />} permissions="view_role" />
            }
          />
          <Route
            path={PATHS.INVOICES.CREATE}
            element={
              <PrivateRoute
                element={<CreateInvoicePage />}
                permissions="CREATE_INVOICE"
              />
            }
          />
          <Route
            path={PATHS.QUOTES.LIST}
            element={
              <PrivateRoute
                element={<QuoteListPage />}
                permissions="READ_QUOTE"
              />
            }
          />
          <Route
            path={PATHS.SIGNATURE.LIST}
            element={
              <PrivateRoute
                element={<SignaturePage />}
                permissions="SIGNATURE"
              />
            }
          />
          <Route
            path={PATHS.SIGNATURE.TABLE_LIST}
            element={
              <PrivateRoute
                element={<ContratsListPage />}
                permissions="SIGNATURE"
              />
            }
          />
          <Route
            path={PATHS.QUOTES.CREATE}
            element={
              <PrivateRoute
                element={<CreateQuotePage />}
                permissions="CREATE_QUOTE"
              />
            }
          />
          <Route
            path={PATHS.AVOIRS.LIST}
            element={
              <PrivateRoute
                element={<AvoirListPage />}
                permissions="READ_CREDIT_NOTE"
              />
            }
          />
          <Route
            path={PATHS.AVOIRS.CREATE}
            element={
              <PrivateRoute
                element={<CreateAvoirPage />}
                permissions="CREATE_CREDIT_NOTE"
              />
            }
          />
          <Route
            path={PATHS.OFFERS}
            element={
              <PrivateRoute element={<OffersPage />} permissions="READ_OFFER" />
            }
          />
          <Route
            path={PATHS.SUPPLIER.LIST}
            element={
              <PrivateRoute
                element={<SuppliersPage />}
                permissions="READ_INVOICE_SUPPLIER"
              />
            }
          />
          <Route
            path={PATHS.SUPPLIER.CONSULT}
            element={
              <PrivateRoute
                element={<SuppliersConsult />}
                permissions="READ_INVOICE_SUPPLIER"
              />
            }
          />
          <Route
            path={PATHS.USERS.LIST}
            element={
              <PrivateRoute element={<UsersPage />} permissions="READ_USER" />
            }
          />
          <Route
            path={PATHS.CLIENTS.LIST}
            element={
              <PrivateRoute
                element={<ClientsPage />}
                permissions="READ_CLIENT"
              />
            }
          />
          <Route
            path={PATHS.EXPENSES.LIST}
            element={
              <PrivateRoute
                element={<ExpensesPage />}
                permissions="CREATE_EXPENSE"
              />
            }
          />
          <Route
            path="/configuration"
            element={
              <PrivateRoute
                element={<CompanyConfig />}
                permissions="CONFIGURATION"
              />
            }
          />
          <Route
            path={PATHS.PACK.LIST}
            element={
              <PrivateRoute element={<Packs />} permissions="READ_PACK" />
            }
          />

          <Route
            path={PATHS.DASHBOARD_USER}
            element={<PrivateRoute element={<DashboardUser />} />}
          />
          {/* DASHBOARD_USER */}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default Router;
